var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.776,11.274c2.205-0.977,3.448-2.813,3.448-5.146c0-2.076-0.836-3.755-2.418-4.852C16.674,0.502,14.951,0,13.038,0H1.946v4.005h2v15.806h-2V24h10.703c1.746,0,4.24-0.264,6.212-1.523c1.912-1.223,2.883-3.075,2.883-5.513C21.544,14.641,19.493,12.477,17.776,11.274z M12.405,9.507H8.902V4.005h3.136c3.118,0,4.39,0.762,4.39,2.629C16.428,8.929,14.23,9.507,12.405,9.507z M8.902,13.689h3.711c3.436,0,4.835,0.895,4.835,3.088c0,2.183-1.681,3.293-4.993,3.293H8.902V13.689z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBold);
export default __webpack_public_path__ + "static/1765983986/media/icon-bold.733df0183308ddadfabf67243123f6d1.svg";
export { ForwardRef as ReactComponent };